// extracted by mini-css-extract-plugin
export default {"postDescriptionV1":"post_description_v1_postDescriptionV1__+z+hu","contentText":"post_description_v1_contentText__WnUgZ","contentName":"post_description_v1_contentName__y2o7g"};